import React, { Fragment } from "react"

// SEO
import { Helmet } from "react-helmet"

// Components
import Topbar from "../Topbar"
import Navbar from "../Navbar"
import Footer from "../Footer"
import Chatbot from "../Chatbot"
import GeoRedirect from "../GeoRedirect"

// Global styles
import "../../styles/global.scss"

class Layout extends React.Component {
  state = { ready: false }
  componentDidMount = () => {
    if (typeof window !== "undefined") {
      const UIkit = require("../../../uikit/dist/js/uikit.min.js")
      const Icons = require("../../../uikit/dist/js/uikit-icons.min.js")
      UIkit.use(Icons)
      this.setState({ ready: true })

      // declaring kadenDigital obj for adobe event trigger
      window.kadenDigital = {
        page: window.location.href,
      }
    }
  }

  render() {
    const { children } = this.props

    const menuNav = [
      {
        label: "Products",
        path: "/products/",
        id: "products",
        children: [
          {
            label: "Wall Mounted Air Conditioning",
            path: "/products/wall-mounted-air-conditioning/",
            img: "/images/nav/Kaden_Web_Banner_600x450px_WallMounted.png",
          },
          {
            label: "Ducted Air Conditioners",
            path: "/products/ducted-air-conditioners/",
            img: "/images/nav/Kaden_Web_Banner_600x450px_Ducted.png",
          },
          {
            label: "Cassette Air Conditioners",
            path: "/products/cassette-air-conditioners/",
            img: "/images/nav/Kaden_Web_Banner_600x450px_Cassette.png",
          },
          {
            label: "Gas Ducted Heating",
            path: "/products/gas-ducted-heating/",
            img: "/images/nav/Kaden_Web_Banner_600x450px_Heating.png",
          },
          {
            label: "Evaporative Cooling",
            path: "/products/evaporative-cooling/",
            img: "/images/nav/Kaden_Web_Banner_600x450px_Evaporative.png",
          },
          {
            label: "Window Air Conditioning",
            path: "/products/window-air-conditioning/",
            img: "/images/nav/kw-window-mega-menu.png",
          },
          {
            label: "Multi Air Conditioning ",
            path: "/products/multi-air-conditioning/",
            img: "/images/nav/multi-ac-mega-menu.jpg",
          },
          {
            label: "View All products",
            path: "/products/",
            img: "/images/nav/kaden_megaMenu_allProducts.png",
            id: "products",
          },
        ],
      },
      {
        label: "Support",
        path: "/support/",
        id: "support",
        children: [
          {
            label: "FAQs",
            path: "/faqs/",
            img: "/images/nav/nav-support-faq.jpg",
          },
          {
            label: "Where to buy",
            path: "/where-to-buy/",
            img: "/images/nav/nav-support-where_to_buy.jpg",
          },
          {
            label: "Request an installer",
            path: "/request-an-installer/",
            img: "/images/nav/nav-support-request_an_installer.jpg",
          },
          {
            label: "Contact us",
            path: "/contact-us/",
            img: "/images/nav/nav-support-contact_us.jpg",
          },
        ],
      },
      {
        label: "Why Kaden",
        path: "/why-kaden/",
        id: "why",
      },
    ]

    const mobileNav = [
      {
        label: "Why Kaden",
        path: "/why-kaden/",
        id: "why",
      },
      {
        label: "Products",
        path: "/products/",
        id: "products",
        children: [
          {
            label: "Wall Mounted Air Conditioning",
            path: "/products/wall-mounted-air-conditioning/",
          },
          {
            label: "Ducted Air Conditioners",
            path: "/products/ducted-air-conditioners/",
          },
          {
            label: "Cassette Air Conditioners",
            path: "/products/cassette-air-conditioners/",
          },
          {
            label: "Gas Ducted Heating",
            path: "/products/gas-ducted-heating/",
          },
          {
            label: "Evaporative Cooling",
            path: "/products/evaporative-cooling/",
          },
          {
            label: "Window Air Conditioning",
            path: "/products/window-air-conditioning/",
          },
          {
            label: "Multi Air Conditioning ",
            path: "/products/multi-air-conditioning/",
          },
          {
            label: "View All Products",
            path: "/products/",
          },
        ],
      },
      {
        label: "Where to buy",
        path: "/where-to-buy/",
        id: "where-to-buy",
      },
      {
        label: "FAQ",
        path: "/faqs/",
        id: "faq",
      },
      {
        label: "Request an installer",
        path: "/request-an-installer/",
        id: "request-an-installer",
      },
      {
        label: "Contact us",
        path: "/contact-us/",
        id: "contact-us",
      },
    ]

    const footerProds = [
      {
        label: "All products",
        path: "/products/",
      },
      {
        label: "<strong>Wall Mounted Air Conditioning</strong>",
        path: "/products/wall-mounted-air-conditioning/",
      },
      {
        label: "<strong>Ducted Air Conditioners</strong>",
        path: "/products/ducted-air-conditioners/",
      },
      {
        label: "<strong>Cassette Air Conditioners</strong>",
        path: "/products/cassette-air-conditioners/",
      },
      {
        label: "<strong>Gas Ducted Heating</strong>",
        path: "/products/gas-ducted-heating/",
      },
      {
        label: "<strong>Evaporative Cooling</strong>",
        path: "/products/evaporative-cooling/",
      },
      {
        label: "<strong>Window Air Conditioning</strong>",
        path: "/products/window-air-conditioning/",
      },
      {
        label: "<strong>Multi Air Conditioning</strong>",
        path: "/products/multi-air-conditioning/",
      },
    ]

    return (
      <div key="wrapper" id="top" className="site-wrap">
        {this.state.ready && (
          <Fragment>
            <Helmet
              script={[
                {
                  src: `${process.env.GATSBY_ADOBE_LAUNCH_URL}`,
                  type: "text/javascript",
                },
              ]}
            />
            <GeoRedirect />
            <Navbar data={menuNav} mobile={mobileNav} />
            <main>{children}</main>
            <Footer prods={footerProds} />
            <Chatbot />
          </Fragment>
        )}
      </div>
    )
  }
}

export default Layout
